import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { Dialog } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContent";
import http from "../Common/RestAPIHandler";
import { connect } from "react-redux";
import { clearUser, setUser } from "../../redux-tools/actions/userActions";
import auth from "../../services/authService";
import SnackbarComponent from "../Common/Snackbar";
import CommonConstants from "../Common/CommonConstants";
import ScreenLoader from "../Common/Loader";
import CancelIcon from "@material-ui/icons/Cancel";
import { makeStyles } from "@material-ui/core/styles";
import {index} from "../Common/Languages";
import MenuItem from "@material-ui/core/MenuItem";
import DialogTitle from "@material-ui/core/DialogTitle";
//import useStyles from "./style";
import Select from "@material-ui/core/Select";
import {PersonalSettings} from "../Common/Languages";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
	colorScheme: {
		color: theme.colorScheme
	},
  input: {
    backgroundColor: theme.inputFields,
    height: 30,
    padding: 0,
    margin: 0,
    fontSize: 14,
  },
  saveButton: {
    borderRadius: 25,
    backgroundColor: theme.colorScheme,
    color: "white",
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: theme.colorScheme,
      color: "white",
      border: "1px solid white",
    },
  },
  rightAlign: {
    textAlign: "right",
    fontSize: 14,
  },
  inputButton: {
    display: "none",
    textAlign: "center",
  },
  uploadButton: {
    border: "1px dashed gray",
    height: 30,
    fontSize: 13,
  },
  hidden: {
    display: "none !important",
  },
  outlinedButton: {
    color: theme.text,
    borderColor: theme.colorScheme
  },
  pageHeader: {
    color: theme.subText,
  },
  pageTitle: {
    color: theme.text,
  },
  subTitle: {
    paddingLeft: theme.spacing(1),
    color: theme.subText,
  },
  viewButtonLabel: {
    textTransform: "none",
    color: theme.linkColor
  },
}));


const MyProfile = (props) => {
  const classes = useStyles();
  const rawLang = localStorage.getItem("languages");
  const lang = (rawLang !== null && !isNaN(rawLang) && parseInt(rawLang) >= 0 && parseInt(rawLang) <= 2) ? parseInt(rawLang) : 0;
  const [user, setUser] = useState({});
  const [prevUserInfo, setPrevUserInfo] = useState({});
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isPasswordMatch, setIsPasswordMatch] = useState(false);
  const [isPasswordEmpty, setIsPasswordEmpty] = useState(false);
  const [isPasswordSameAsOrignal, setIsPasswordSameAsOriginal] = useState(
    false
  );
  const [isPasswordWhitespace, setIsPasswordWhitespace] = useState(false);
  const [userError, setUserError] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState();
  const [snackBarSeverity, setSnackBarSeverity] = useState("success");
  const errorMessage = CommonConstants.error;
  const [loadData, setLoadData] = useState(false);

  useEffect(() => {
    setLoadData(true);
    http.Get(
      `tenant_user_profile/`,
      (user) => {
        setUser(user);
        setPrevUserInfo(user);
        setLoadData(false);
      },
      () => {
        setLoadData(false);
      }
    );
  }, []);

  const handleToClose = () => {
    setIsConfirmed(false)
  }
  const onSubmit = () => {
    setIsConfirmed(true)
  }
  const handleToSave = () => {
    setIsConfirmed(false)
    if (!(user.mobile && user.country_code)) {
      setIsMobile(true);
      return;
    }
    const data = new FormData();
    for (var key in user) {
      if (user[key] || ["area_code", "phone"].includes(key) || user[key]===0) {
        data.append(key, user[key]);
      }
    }

    if(!user.profile_image){
        data.append("profile_image", "");
    }
    else if(!user.profile_image.name){
        data.delete("profile_image");
    }

    if (user.current_password || user.retype_password || user.new_password) {
      if (user.current_password) {
        if (user.retype_password && user.new_password) {
          if (user.current_password === user.new_password) {
            setIsPasswordSameAsOriginal(true);
            return;
          } else {
            let str = user.new_password;
            if (str.charAt(0) === " " || str.charAt(str.length - 1) === " ") {
              setIsPasswordWhitespace(true);
              return;
            }
          }
          if (user.retype_password === user.new_password) {
            setIsSubmitted(true);
            http.Put(
              `tenant_user_profile/`,
              data,
              (userData) => {
                // Password was changed, need to logout and re-authenticate
                setSnackBarMessage("Password updated successfully. Please login again.");
                setSnackBarSeverity("success");
                setTimeout(() => {
                  auth.deleteToken();
                  props.clearUser();
                  props.history.replace(process.env.PUBLIC_URL + "/login");
                }, 2000);
              },
              (status, error) => {
                if (status === 400 && error.invalid_password) {
                  setIsPasswordValid(true);
                }
                setUserError(error);
                setIsSubmitted(false);
              }
            );
          } else {
            setIsPasswordMatch(true);
          }
        } else {
          setIsPasswordEmpty(true);
        }
      } else {
        setIsPasswordEmpty(true);
      }
    } else {
      setIsSubmitted(true);
      http.Put(
        `tenant_user_profile/`,
        data,
        (userData) => {
          // Only logout for email changes (security sensitive)
          if (prevUserInfo.email !== userData.email) {
            setSnackBarMessage("Email updated successfully. Please login again to verify your new email.");
            setSnackBarSeverity("success");
            setTimeout(() => {
              auth.deleteToken();
              props.clearUser();
              props.history.replace("/login");
            }, 2000);
          } else {
            // For other updates (mobile, phone, color scheme, language), just refresh data
            props.setUser(userData);
            setUser(userData);
            setPrevUserInfo(userData);
            setIsSubmitted(false);
            setUserError({}); // Clear any previous errors
            setIsMobile(false); // Clear mobile validation state
            setSnackBarMessage("Profile updated successfully!");
            setSnackBarSeverity("success");
          }
        },
        (status, error) => {
          setUserError(error);
          setIsSubmitted(false);
        }
      );
    }
  };

  const onChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
    if (e.target.name === "mobile" || e.target.name === "country_code")
      setIsMobile(false);
    if (e.target.name === "mobile") {
      setUserError({
        ...userError,
        [e.target.name]: null,
        cellphone: null,
      });
    } else {
      setUserError({
        ...userError,
        [e.target.name]: null,
      });
    }
    setIsPasswordMatch(false);
    setIsPasswordValid(false);
    setIsPasswordSameAsOriginal(false);
    setIsPasswordWhitespace(false);
    setIsSubmitted(false);
  };

  const handleFile = (e) => {
    setUser({
      ...user,
      profile_image: e.target.files[0],
    });
    setUserError({
      ...userError,
      profile_image: null,
    });
  };

  return (
  <>
    <SnackbarComponent
      message={snackBarMessage}
      open={!!snackBarMessage}
      handleSnackBarClose={() => {
        setSnackBarMessage(null);
      }}
      severity={snackBarSeverity}
    />
    <Dialog open={isConfirmed} onClose={handleToClose}>
          <DialogTitle>{PersonalSettings.message1[lang]}:</DialogTitle>
          <DialogContentText>
              {user.current_password&&<div> - {PersonalSettings.Password[lang]}</div>}
              {prevUserInfo.email !== user.email&&<div> - {PersonalSettings.Email[lang]}</div>}
              {prevUserInfo.mobile !== user.mobile&&<div> - {PersonalSettings.Mobile[lang]}</div>}
              {prevUserInfo.top_nav_back_colour !== user.top_nav_back_colour&&<div> - {PersonalSettings.ColorScheme[lang]}</div>}
              {prevUserInfo.phone !== user.phone&&<div> - {PersonalSettings.Phone[lang]}</div>}
              {prevUserInfo.text_language !== user.text_language&&<div> - {PersonalSettings.Language[lang]}</div>}
              {(user.profile_image && user.profile_image.name) && <div> - {PersonalSettings.ProfileImage[lang]}</div>}
              {(user.profile_image === null && prevUserInfo.profile_image_src) && <div> - {PersonalSettings.ProfileImage[lang]}</div>}
          </DialogContentText>

          <DialogContentText>
              {!(
                  user.current_password ||
                  prevUserInfo.email !== user.email ||
                  prevUserInfo.mobile !== user.mobile ||
                  prevUserInfo.top_nav_back_colour !== user.top_nav_back_colour ||
                  prevUserInfo.phone !== user.phone ||
                  prevUserInfo.text_language !== user.text_language ||
                  (user.profile_image && user.profile_image.name) ||
                  (user.profile_image === null && prevUserInfo.profile_image_src)
              )&&<div>{PersonalSettings.message3[lang]}.</div>}
          </DialogContentText>
      <DialogActions>
              {(
                  user.current_password ||
                  prevUserInfo.email !== user.email ||
                  prevUserInfo.mobile !== user.mobile ||
                  prevUserInfo.top_nav_back_colour !== user.top_nav_back_colour ||
                  prevUserInfo.phone !== user.phone ||
                  prevUserInfo.text_language !== user.text_language ||
                  (user.profile_image && user.profile_image.name) ||
                  (user.profile_image === null && prevUserInfo.profile_image_src)
              )&&
          <Button onClick={handleToSave}
              className={classes.outlinedButton} autoFocus>
              {PersonalSettings.Confirmed[lang]}
          </Button>}
          <Button onClick={handleToClose}
              className={classes.outlinedButton} autoFocus>
              {PersonalSettings.Close[lang]}
          </Button>
      </DialogActions>
    </Dialog>
    <div className={classes.root}>
      <ValidatorForm onSubmit={onSubmit} autoComplete="off">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <span className={classes.pageHeader}>{props.user.company_name}</span>
            <span className={classes.colorScheme}> | </span>
            <span className={classes.pageHeader}>{PersonalSettings.Settings[lang]}</span>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.pageTitle}>{PersonalSettings.MyProfile[lang]}</Typography>
          </Grid>
          <Grid item xs={12}>
            {loadData ? (
              <ScreenLoader />
            ) : (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="subtitle1" noWrap className={classes.pageTitle}>
                            {PersonalSettings.USERSETTINGS[lang]}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid item xs={12}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid
                                item
                                xs={4}
                                sm={2}
                                md={2}
                                lg={2}
                                className={classes.rightAlign}
                              >
                                <span className={classes.subTitle}>{PersonalSettings.ProfileImage[lang]}</span>
                              </Grid>
                              <Grid item xs={8} sm={5} md={4} lg={3}>
                                <Button
                                  variant="text"
                                  fullWidth
                                  component="label"
                                  classes={{ label: classes.viewButtonLabel }}
                                  className={classes.uploadButton}
                                  color="primary"
                                >
                                  {PersonalSettings.Upload[lang]}
                                  <input
                                    type="file"
                                    onChange={handleFile}
                                    className={classes.inputButton}
                                  />
                                </Button>
                              </Grid>
                            </Grid>
                            {user.profile_image && user.profile_image.name && (
                              <Grid container spacing={2} alignItems="center">
                                <Grid item xs={4} sm={2} md={2} lg={2}></Grid>
                                <Grid item xs>
                                  <span className={classes.pageTitle}>{user.profile_image.name}</span>
                                </Grid>
                              </Grid>
                            )}
                            {user.profile_image && !user.profile_image.name && (
                              <Grid container spacing={2} alignItems="center">
                                <Grid item xs={4} sm={2} md={2} lg={2}></Grid>
                                <Grid item xs>
                                  <img
                                    height="100px"
                                    alt={user.id}
                                    src={user["profile_image_src"]}
                                  />
                                    <IconButton
                                      className={classes.outlinedButton}
                                      onClick={(e) => {
                                            setUser({
                                              ...user,
                                              profile_image: null,
                                            });
                                      }}
                                    >
                              <CancelIcon />
                            </IconButton>
                                </Grid>
                              </Grid>
                            )}
                            {userError.profile_image && (
                              <Grid container spacing={2} alignItems="center">
                                <Grid item xs={4} sm={2} md={2} lg={2}></Grid>
                                <Grid item xs style={{ color: "red" }}>
                                  {userError.profile_image[0]}
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid
                                item
                                xs={4}
                                sm={2}
                                md={2}
                                lg={2}
                                className={classes.rightAlign}
                              >
                                <span className={classes.subTitle}>{PersonalSettings.Email[lang]}</span>
                              </Grid>
                              <Grid item xs={8} className={classes.hidden}>
                                <TextValidator
                                  id="email"
                                  type="text"
                                  fullWidth
                                  value=""
                                  margin="dense"
                                  variant="outlined"
                                  name="email"
                                  // InputProps={{ className: classes.input }}
                                />
                              </Grid>
                              <Grid item xs={8} sm={7} md={6} lg={4}>
                                <TextValidator
                                  id="email"
                                  fullWidth
                                  margin="dense"
                                  variant="outlined"
                                  onChange={onChange}
                                  name="email"
                                  value={user.email || ""}
                                  // InputProps={{ className: classes.input }}
                                  validators={["required"]}
                                  errorMessages={[errorMessage.requiredError]}
                                  error={Boolean(userError.email)}
                                  helperText={
                                    userError.email && userError.email[0]
                                  }
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          <Grid item xs={12}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid
                                item
                                xs={4}
                                sm={2}
                                md={2}
                                lg={2}
                                className={classes.rightAlign}
                              >
                                <span className={classes.subTitle}>{PersonalSettings.Phone[lang]}</span>
                              </Grid>
                              <Grid item xs={5} sm={5} md={4} lg={3}>
                                <TextValidator
                                  id="phone"
                                  fullWidth
                                  margin="dense"
                                  variant="outlined"
                                  onChange={onChange}
                                  placeholder={PersonalSettings.Phone[lang]}
                                  name="phone"
                                  value={user.phone || ""}
                                  // InputProps={{ className: classes.input }}
                                />
                              </Grid>
                              <Grid item xs={3} sm={2} md={2} lg={1}>
                                <TextValidator
                                  id="area_code"
                                  fullWidth
                                  margin="dense"
                                  variant="outlined"
                                  onChange={onChange}
                                  placeholder={PersonalSettings.ext[lang]}
                                  name="area_code"
                                  value={user.area_code || ""}
                                  // InputProps={{ className: classes.input }}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid
                                item
                                xs={4}
                                sm={2}
                                md={2}
                                lg={2}
                                className={classes.rightAlign}
                              >
                                <span className={classes.subTitle}>{PersonalSettings.Mobile[lang]}</span>
                              </Grid>
                              <Grid item xs={3} sm={2} md={2} lg={1}>
                                <TextValidator
                                  id="country_code"
                                  fullWidth
                                  margin="dense"
                                  variant="outlined"
                                  onChange={onChange}
                                  placeholder={PersonalSettings.ext[lang]}
                                  name="country_code"
                                  value={user.country_code || ""}
                                  error={Boolean(userError.country_code || userError.mobile)}
                                  // InputProps={{ className: classes.input }}
                                />
                              </Grid>
                              <Grid item xs={5} sm={5} md={4} lg={3}>
                                <TextValidator
                                  id="mobile"
                                  fullWidth
                                  margin="dense"
                                  variant="outlined"
                                  onChange={onChange}
                                  placeholder={PersonalSettings.Mobile[lang]}
                                  name="mobile"
                                  value={user.mobile || ""}
                                  error={Boolean(userError.country_code || userError.mobile)}
                                  // InputProps={{ className: classes.input }}
                                />
                              </Grid>
                            </Grid>
                            {(userError.country_code ||
                              userError.mobile ||
                              userError.cellphone ||
                              isMobile) && (
                              <Grid container spacing={2} alignItems="center">
                                <Grid item xs={4} sm={2} md={2} lg={2}></Grid>
                                <Grid item xs style={{ color: "red" }}>
                                  {userError.mobile || 
                                   userError.country_code ||
                                   (userError.cellphone
                                     ? " Mobile no " + userError.cellphone
                                     : "") || 
                                   (isMobile && !userError.mobile && !userError.country_code
                                     ? errorMessage.bothRequired
                                     : "")}
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                          <Grid container spacing={2} alignItems="center">
                              <Grid
                                item
                                xs={4}
                                sm={2}
                                md={2}
                                lg={2}
                                className={classes.rightAlign}
                              >
                                <span className={classes.subTitle}>{PersonalSettings.Languages[lang]}</span>
                              </Grid>
                              <Grid item xs={8} sm={7} md={6} lg={4}>
                                <Select
                                  className={classes.input}
                                  fullWidth
                                  name="text_language"
                                  variant="outlined"
                                  value={user.text_language|| 0}
                                  onChange={onChange}
                                >
                                  {index.map(({ value, label }) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
                                </Select>
                              </Grid>
                          </Grid>
                          <Grid container spacing={2} alignItems="center">
                              <Grid
                                item
                                xs={4}
                                sm={2}
                                md={2}
                                lg={2}
                                className={classes.rightAlign}
                              >
                                <span className={classes.subTitle}>{PersonalSettings.Theme[lang]}</span>
                              </Grid>
                              <Grid item xs={8} sm={7} md={6} lg={4}>
                                <Select
                                  className={classes.input}
                                  fullWidth
                                  name="top_nav_back_colour"
                                  variant="outlined"
                                  value={user.top_nav_back_colour || ""}
                                  onChange={onChange}
                                >
                                  <MenuItem key="Dark" value={"Dark"}>{PersonalSettings.Dark[lang]}</MenuItem>
                                  <MenuItem key="Light" value={"Light"}>{PersonalSettings.Light[lang]}</MenuItem>
                                </Select>
                              </Grid>
                            </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="body1" noWrap className={classes.pageTitle}>
                          {PersonalSettings.CHANGEPASSWORD[lang]}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12}>
                              <Grid container spacing={2} alignItems="center">
                                <Grid
                                  item
                                  xs={4}
                                  sm={2}
                                  md={2}
                                  lg={2}
                                  className={classes.rightAlign}
                                >
                                  <span className={classes.subTitle}>{PersonalSettings.CurrentPassword[lang]}</span>
                                </Grid>

                                <Grid item xs={8} sm={7} md={6} lg={4}>
                                  <TextValidator
                                    autoComplete="current-password"
                                    type="password"
                                    id="current_password"
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    onChange={onChange}
                                    name="current_password"
                                    value={user.current_password || ""}
                                    // InputProps={{ className: classes.input }}
                                    error={
                                      (isPasswordEmpty &&
                                        !user.current_password) ||
                                      isPasswordValid
                                    }
                                    helperText={
                                      (isPasswordEmpty &&
                                        !user.current_password &&
                                        errorMessage.requiredError) ||
                                      (isPasswordValid &&
                                        errorMessage.passwordInvalid)
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container spacing={2} alignItems="center">
                                <Grid
                                  item
                                  xs={4}
                                  sm={2}
                                  md={2}
                                  lg={2}
                                  className={classes.rightAlign}
                                >
                                  <span className={classes.subTitle}>{PersonalSettings.NewPassword[lang]}</span>
                                </Grid>
                                <Grid item xs={8} className={classes.hidden}>
                                  <TextValidator
                                    autoComplete="current-password"
                                    type="password"
                                    id="current_password"
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    name="current_password"
                                    // InputProps={{ className: classes.input }}
                                  />
                                </Grid>
                                <Grid item xs={8} sm={7} md={6} lg={4}>
                                  <TextValidator
                                    id="new_password"
                                    autoComplete="new-password"
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    onChange={onChange}
                                    name="new_password"
                                    value={user.new_password || ""}
                                    // InputProps={{ className: classes.input }}
                                    type="password"
                                    validators={
                                      user.new_password && [
                                        "minStringLength:8",
                                        "matchRegexp:(?=.*[A-Z])",
                                        "matchRegexp:(?=.*[0-9])",
                                        "matchRegexp:(?=.*[!@#$%^&*'+])",
                                      ]
                                    }
                                    errorMessages={[
                                      errorMessage.eightChar,
                                      errorMessage.uppercase,
                                      errorMessage.numeric,
                                      errorMessage.specialChar,
                                    ]}
                                    error={
                                      (isPasswordEmpty && !user.new_password) ||
                                      isPasswordSameAsOrignal ||
                                      isPasswordWhitespace ||
                                      isPasswordMatch ||
                                      userError.password
                                    }
                                    helperText={
                                      (isPasswordSameAsOrignal &&
                                        "New password and current password cannot be same.") ||
                                      (isPasswordEmpty &&
                                        !user.new_password &&
                                        errorMessage.requiredError) ||
                                      (isPasswordWhitespace &&
                                        "Cannot contain leading or trailing whitespace.") ||
                                      (isPasswordMatch &&
                                        errorMessage.passwordMismatch) ||
                                      (userError.password && userError.password)
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container spacing={2} alignItems="center">
                                <Grid
                                  item
                                  xs={4}
                                  sm={2}
                                  md={2}
                                  lg={2}
                                  className={classes.rightAlign}
                                >
                                  <span className={classes.subTitle}>{PersonalSettings.RetypePassword[lang]}</span>
                                </Grid>
                                <Grid item xs={8} sm={7} md={6} lg={4}>
                                  <TextValidator
                                    autoComplete="retype-password"
                                    id="retype_password"
                                    fullWidth
                                    margin="dense"
                                    variant="outlined"
                                    onChange={onChange}
                                    name="retype_password"
                                    value={user.retype_password || ""}
                                    // InputProps={{ className: classes.input }}
                                    type="password"
                                    error={
                                      (isPasswordEmpty &&
                                        !user.retype_password) ||
                                      isPasswordMatch
                                    }
                                    helperText={
                                      (isPasswordEmpty &&
                                        !user.retype_password &&
                                        errorMessage.requiredError) ||
                                      (isPasswordMatch &&
                                        errorMessage.passwordMismatch)
                                    }
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={6}>
                              <Grid container spacing={2} justifyContent="flex-end">
                                <Grid item>
                                  <Button
                                    className={classes.outlinedButton}
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    type="submit"
                                    onChange={onChange}
                                    disabled={isSubmitted}
                                  >
                                    {PersonalSettings.Save[lang]}
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </ValidatorForm>
    </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
  };
};

export default connect(mapStateToProps, { clearUser, setUser })(MyProfile);
